/* tslint:disable */
/* eslint-disable */
export enum WorkMailSignatureSourceEnum {
  Provider = 'PROVIDER',
  WorkOffice = 'WORK_OFFICE'
}
